module.exports = __webpack_public_path__ + "static/media/hangman_6.56bdf97b.svg";